import React from 'react'
import { FiUsers, FiClipboard, FiDollarSign, FiTrendingUp } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import './css/JoinProvider.css'

const benefits = [
  {
    icon: <FiUsers />,
    title: 'Alcanza más clientes',
    description: 'Recibe solicitudes calificadas desde toda la red Flotte sin comisiones ocultas.'
  },
  {
    icon: <FiClipboard />,
    title: 'Gestiona fácilmente',
    description: 'Panel unificado para cotizaciones, documentación y seguimiento en tiempo real.'
  },
  {
    icon: <FiDollarSign />,
    title: 'Optimiza tus ingresos',
    description: 'Define tarifas dinámicas, aplica descuentos programados y recibe pagos seguros.'
  },
  {
    icon: <FiTrendingUp />,
    title: 'Crece con analíticos',
    description: 'Reportes de desempeño, puntualidad y satisfacción para impulsar tu operación.'
  }
]

export default function JoinProvider() {
  return (
    <section className="section join-provider" aria-labelledby="join-provider-title">
      <div className="join-provider__content">
        <h2 id="join-provider-title" className="section-title">
          ¿Eres proveedor?
        </h2>
        <p className="sub-title">
          Súmate a la red Flotte y accede a clientes empresariales, herramientas digitales y soporte especializado.
        </p>
      </div>

      <div className="join-grid">
        {benefits.map(item => (
          <article key={item.title} className="join-card">
            <div className="join-card__icon" aria-hidden="true">
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>

      <div className="join-cta">
        <p>
          Publica tus unidades, establece tu disponibilidad y comienza a recibir envíos en menos de 24 horas.
        </p>
        <Link to="/register/provider" className="btn-join">
          Únete como proveedor
        </Link>
      </div>
    </section>
  )
}
